import { Position } from '@volkswagen-onehub/audi-feature-service-visitor-locator';
import mapContext from '../contexts/map-context';
import { ActionTypes } from '../contexts/reducers/map-reducer';
import locatorServiceContext from '../contexts/visitor-locator-service-context';
import trackingContext from '../contexts/tracking-context';
import { trackUserLocationAction } from '../utils/trackingUtils';

import { TrackingEvents } from '../utils/trackingService';
import { LocationServiceErrorMessages } from '../models/common/locationServiceErrorMessages';

export const useGeolocation = () => {
  const dispatch = mapContext.useMapDispatch();
  const { showAddress, marketGoogleKey, isUserPositionUsed, isMapTriggeredByTeaser } =
    mapContext.useMapState();
  const { visitorLocatorService } = locatorServiceContext.useVisitorLocatorServiceState();
  const { trackingService: tService } = trackingContext.useTrackingState();

  const getUserPosition = async (): Promise<Position> => {
    if (!visitorLocatorService) {
      throw new Error(LocationServiceErrorMessages.VISITOR_LOCATOR_UNDEFINED);
    }
    try {
      const position = await visitorLocatorService.getLocation({
        searchAddress: showAddress,
        googleAPIKey: marketGoogleKey,
        detectionMethods: ['BrowserNavigator'],
        addressComponents: ['locality', 'country'],
      });
      dispatch({ type: ActionTypes.setUserLocationError, payload: false });
      dispatch({ type: ActionTypes.setUserGiveLocationPermission, payload: true });
      return position;
      // eslint-disable-next-line
    } catch (err: any) {
      if (err.message === LocationServiceErrorMessages.USER_DECLINED) {
        dispatch({ type: ActionTypes.setUserGiveLocationPermission, payload: false });
        trackUserLocationAction(tService, TrackingEvents.LOCATION_NOT_RETRIEVED_PERMISSION_DENIED);
      } else if (err.message === LocationServiceErrorMessages.IP_GEOLOCATION_FAILED) {
        dispatch({ type: ActionTypes.setUserGiveLocationPermission, payload: false });
        trackUserLocationAction(
          tService,
          TrackingEvents.LOCATION_NOT_RETRIEVED_IP_GEOLOCATION_NOT_RESOLVED,
        );
      } else {
        dispatch({ type: ActionTypes.setUserGiveLocationPermission, payload: true });
      }
      dispatch({ type: ActionTypes.setUserLocationError, payload: true });
      throw err;
    }
  };

  const triggerGeolocationSearch = async (): Promise<void> => {
    try {
      const { coordinates, address, locality } = await getUserPosition();
      if (!isUserPositionUsed) {
        dispatch({ type: ActionTypes.resetGeolocationSearch, payload: null });
      }
      dispatch({ type: ActionTypes.setIsUserPositionUsed, payload: true });
      if (!isMapTriggeredByTeaser) {
        dispatch({ type: ActionTypes.setSearchGeoLocation, payload: coordinates });
        dispatch({ type: ActionTypes.setSearchText, payload: address });
        dispatch({ type: ActionTypes.setQuery, payload: locality?.longName });
        dispatch({ type: ActionTypes.setPlaceId, payload: '' });
        dispatch({ type: ActionTypes.setSelectedDealerId, payload: null });
        dispatch({ type: ActionTypes.setDealerReviews, payload: [] });
        dispatch({ type: ActionTypes.setRatingSummary, payload: null });
      }
      dispatch({ type: ActionTypes.setUpdateMapZoomLevel, payload: true });
      dispatch({ type: ActionTypes.setUserGeoLocation, payload: coordinates });
      dispatch({ type: ActionTypes.resetIsMapTriggeredByTeaser });
    } catch (err) {
      dispatch({ type: ActionTypes.setShowLocationError, payload: true });
      throw err;
    }
  };

  return {
    getUserPosition,
    triggerGeolocationSearch,
  };
};
